<template>
  <div :class="pageCls">
    <div class="d1">
      <div class="b2"></div>
      <div class="b3"></div>
      <div class="b1"></div>
    </div>
    <div class="d2"></div>
    <div class="d3">
      <div class="b1" @click="btnClick"></div>
    </div>
    <div class="d4"></div>
    <div :class="onNum==1 ? 'd5 on' : 'd5'" @click="onClick(1)"></div>
    <div :class="onNum==2 ? 'd6 on' : 'd6'" @click="onClick(2)"></div>
    <div :class="onNum==3 ? 'd7 on' : 'd7'" @click="onClick(3)"></div>
    <div class="d8"></div>
  </div>
</template>

<script>
export default {
  name: 'Page2',
  props: {
    userData: Object
  },
  data(){
    return{
      onNum:0,
      pageCls:"page2"
    }
  },
  mounted(){
  },
  methods:{
    btnClick(){
      if(this.onNum == 0){
        return false;
      }
      this.$emit('setUser',"sel1",this.onNum);
      this.pageCls = "page2 page2_2";
      setTimeout(() => {
        this.$emit('setPage',3);
      }, 2000);
    },
    onClick(n){
      this.onNum = n;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page2{
  position: absolute;
  left:0;
  top:0;
  right:0;
  bottom:0;
  background: #1b1b1b;
  .d1{
    position: absolute;
    left:0;
    bottom:0;
    width: 100%;
    height: 100%;
    transform: translateY(-100%);
    animation:1s linear 1 transformAni2;
    animation-fill-mode: forwards;
    &:before{
      content: '';
      position: absolute;
      left:0;
      top:0;
      width: 100%;
      height: 60%;
      background: #b2b1d9;
    }
    .b3{
      &:before{
        content: '';
        position: absolute;
        left:-2.88rem;
        top:0.8rem;
        width: 2.88rem;
        height: 0.46rem;
        background: url(../assets/bg20.png) no-repeat 50% 50% / 100% 100%;
        transform: translateX(150vw);
        animation:10s linear infinite transformAni2;
      }
      &::after{
        content: '';
        position: absolute;
        left:-2.88rem;
        top:5rem;
        width: 2.02rem;
        height: 0.28rem;
        background: url(../assets/bg21.png) no-repeat 50% 50% / 100% 100%;
        transform: translateX(150vw);
        animation:10s 1.5s linear infinite transformAni2;
      }
    }
    .b2{
      &:before{
        content: '';
        position: absolute;
        left:-2.88rem;
        top:1.7rem;
        width: 2.13rem;
        height: 0.43rem;
        background: url(../assets/bg22.png) no-repeat 50% 50% / 100% 100%;
        transform: translateX(150vw);
        animation:10s 5s linear infinite transformAni2;
      }
      &::after{
        content: '';
        position: absolute;
        left:-2.88rem;
        top:3.1rem;
        width: 2.64rem;
        height: 0.45rem;
        background: url(../assets/bg23.png) no-repeat 50% 50% / 100% 100%;
        transform: translateX(150vw);
        animation:10s 7s linear infinite transformAni2;
      }
    }
    .b1{
      position: absolute;
      right:-0.1rem;
      top:50%;
      width: 2rem;
      height: 2rem;
      margin:-4.8rem 0 0 0;
      transform: translate(2rem,2rem);
      animation:1s 1s linear 1 transformAni2;
      animation-fill-mode: forwards;
      &::before{
        content: '';
        position: absolute;
        left:50%;
        top:50%;
        width: 20rem;
        height: 20rem;
        margin:-10rem 0 0 -10rem;
        background: url(../assets/bg25.png) no-repeat 50% 50% / 100% auto;
        transform: rotate(360deg);
        animation:30s 2s linear infinite d1b1Ani;
        opacity: 0;
      }
      &::after{
        content: '';
        position: absolute;
        right:0;
        top:0;
        width: 2rem;
        height: 2rem;
        background: url(../assets/bg26.png) no-repeat 0 0 / 100% 100%;
      }
    }
    &::after{
      content: '';
      position: absolute;
      left:0;
      top:50%;
      width: 100%;
      height: 9.75rem;
      margin:-2.5rem 0 0 0;
      background: url(../assets/bg24.png) no-repeat 0 0 / 100% 100%;
    }
  }
  .d2{
    position: absolute;
    left:0;
    top:0;
    width: 1.8rem;
    height: 0.5rem;
    background: url(../assets/bg18.png) no-repeat 0 0 / 100% 100%;
    opacity: 0;
    animation:0.5s 1s linear 1 opacityAni2;
    animation-fill-mode: forwards;
  }
  .d3{
    position: absolute;
    left:0;
    bottom:0;
    width: 100%;
    height: 1.91rem;
    background: url(../assets/bg28.png) no-repeat 0 0 / 100% 100%;
    opacity: 0;
    animation:0.5s 1s linear 1 opacityAni2;
    animation-fill-mode: forwards;
    .b1{
      position: absolute;
      right:0.3rem;
      top:0.5rem;
      width: 2.42rem;
      height: 0.92rem;
      background: url(../assets/bg27.png) no-repeat 0 0 / 100% 100%;
      transform: scale(1.1);
      animation:1s linear infinite transformAni;
    }
  }
  .d4{
    position: absolute;
    left:0;
    top:50%;
    width: 5.44rem;
    height: 3.32rem;
    margin:-5.75rem 0 0 0;
    background: url(../assets/bg19.png) no-repeat 0 0 / 100% 100%;
    transform: translateX(-6rem);
    animation:0.5s 2.5s linear 1 transformAni2;
    animation-fill-mode: forwards;
  }
  .d5{
    position: absolute;
    left:1.65rem;
    top:50%;
    width: 4.76rem;
    height: 2.22rem;
    margin:-1.4rem 0 0 0;
    background: url(../assets/bg29.png) no-repeat 0 0 / 100% 100%;
    transform: translateY(-100vh);
    animation:1.2s 3s linear 1 transformAni2;
    animation-fill-mode: forwards;
    &:active,&:hover{
      left:1.45rem;
      width: 5.16rem;
      height: 2.42rem;
      margin:-1.5rem 0 0 0;
    }
    &:visited,&:link{
      left:1.65rem;
      width: 4.76rem;
      height: 2.22rem;
      margin:-1.4rem 0 0 0;
    }
    &.on{
      background: url(../assets/bg30.png) no-repeat 0 0 / 100% 100%;
    }
  }
  .d6{
    position: absolute;
    left:0.3rem;
    top:50%;
    width: 4.85rem;
    height: 2.18rem;
    margin:0.8rem 0 0 0;
    background: url(../assets/bg31.png) no-repeat 0 0 / 100% 100%;
    transform: translateX(-100vw);
    animation:1s 3.2s linear 1 transformAni2;
    animation-fill-mode: forwards;
    &:active,&:hover{
      left:0.1rem;
      width: 5.25rem;
      height: 2.38rem;
      margin:0.7rem 0 0 0;
    }
    &:visited,&:link{
      left:0.3rem;
      width: 4.85rem;
      height: 2.18rem;
      margin:0.8rem 0 0 0;
    }
    &.on{
      background: url(../assets/bg32.png) no-repeat 0 0 / 100% 100%;
    }
  }
  .d7{
    position: absolute;
    left:2.65rem;
    top:50%;
    width: 4.52rem;
    height: 2rem;
    margin:2.8rem 0 0 0;
    background: url(../assets/bg33.png) no-repeat 0 0 / 100% 100%;
    transform: translateX(100vw);
    animation:1s 3.2s linear 1 transformAni2;
    animation-fill-mode: forwards;
    &:active,&:hover{
      left:2.45rem;
      width: 4.92rem;
      height: 2.2rem;
      margin:2.7rem 0 0 0;
    }
    &:visited,&:link{
      left:2.65rem;
      width: 4.52rem;
      height: 2rem;
      margin:2.8rem 0 0 0;
    }
    &.on{
      background: url(../assets/bg34.png) no-repeat 0 0 / 100% 100%;
    }
  }
}
.page2_2{
  // transform:translate(0);
  // opacity: 1;
  // animation:0.2s 1.8s linear 1 opacityAni;
  // animation-fill-mode: forwards;
  // .d1 .b1{
  //   transform:translate(0);
  //   opacity: 1;
  //   animation:0.2s 1.4s linear 1 opacityAni;
  //   animation-fill-mode: forwards;
  // }
  .d3,.d4,.d5,.d6,.d7{
    transform:translate(0);
    opacity: 1;
    animation:0.5s linear 1 opacityAni;
    animation-fill-mode: forwards;
  }
  .d8{
    position: absolute;
    left:50%;
    top:50%;
    width: 5.4rem;
    height: 5.33rem;
    margin:-2.5rem 0 0 -2.7rem;
    background: url(../assets/bg35.png) no-repeat 0 0 / 100% 100%;
    animation:1.5s 0.5s linear 1 d8Ani;
    animation-fill-mode: forwards;
    transform: translateY(80vH);
  }
}
@keyframes d1b1Ani {
  0%{opacity: 1;}
  100%{
    opacity: 1;
    transform:none;
  }
}
@keyframes d8Ani {
  0%{
    transform: translateY(80vH) scale(1);
  }
  100%{
    transform: scale(0.18);
  }
}
</style>
